import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const DailyBonusesListComponent = React.lazy(() => import('./components/DailyBonusesList'));

const DailyBonusesList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <DailyBonusesListComponent />
      </Suspense>
    </div>
  );
};

export default DailyBonusesList;
